"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated `@faire/slate/icons/Send` instead */
export const Send = createSVGIcon(
  <path
    d="m9.973 18.844 3.741 3.735a1.926 1.926 0 0 0 3.19-.753l6.14-18.433A1.926 1.926 0 0 0 20.606.957L2.173 7.1a1.927 1.927 0 0 0-.752 3.185L6.12 14.99l-.16 5.94zM22.493 1.34 6.12 14.989"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "Send",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      defaultMessage: "Send",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    color: Core.icon.default,
  })
);
